/* tslint:disable:indent */
/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import { NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import {CommonModule, JsonPipe} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { RouterModule } from '@angular/router';
import { routes } from './transaction-reports.routing';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PipesModule } from '../pipes/pipes.module';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from '../../modules/shared.module';
import {
  MatAutocompleteModule, MatButtonModule,
  MatDialogModule, MatFormFieldModule, MatInputModule,
  MatRadioModule,
} from '@angular/material';
import { OverlayPanelModule, TooltipModule } from 'primeng/primeng';
import { AppColoredLabelModule } from '../../components/app-colored-label/app-colored-label.module';
import { UnityChartModule } from '../../components/unity-chart/unity-chart.module';
import { AppSpinnerDivModule } from '../../components/app-spinner-div/app-spinner-div.module';
import { LocalDatePipe } from '../pipes/local-date.pipe';
import { DisplayFieldPipe } from '../pipes/displayField.pipe';
import { CurrencyPipe } from '@angular/common';
import {
  DownloadDialogComponent,
  TransactionDurationReportComponent
} from './transaction-duration-report/transaction-duration-report.component';
import {TableExtensionService} from '../../services/table-extension.service';
import {SortService} from '../../services/sort.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ChartModule} from 'angular-highcharts';
import {AsnRunTimeListComponent,
	AsnRuntimeDownloadDialogComponent
} from './asn-run-time-list/asn-run-time-list.component';
import {OrderConfirmationRunTimeComponent,
	ConfirmationDownloadDialogComponent
} from './order-confirmation-run-time/order-confirmation-run-time.component';
import {ApisRunTimeComponent,
	ApisRunTimeDownloadDialogComponent
} from './apis-run-time/apis-run-time.component';
import {InvoiceRunTimeComponent,
	InvoiceRuntimeDownloadDialogComponent
} from './invoice-run-time/invoice-run-time.component';
import {TransactionDurationReportCapacityComponent,
    TransactionDurationReportCapacityDownloadDialogComponent
} from './transaction-duration-report-capacity/transaction-duration-report-capacity.component';

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    NgxPaginationModule,
    NgxDatatableModule,
    LoadingModule,
    NgxPermissionsModule.forChild(),
    NgbModule,
    RouterModule.forChild(routes),
    PipesModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    SharedModule,
    MatDialogModule,
    TooltipModule,
    MatAutocompleteModule,
    OverlayPanelModule,
    AppColoredLabelModule,
    MatRadioModule,
    UnityChartModule,
    AppSpinnerDivModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    ChartModule,
    MatButtonModule,
  ],
  providers: [
    LocalDatePipe,
    DisplayFieldPipe,
    CurrencyPipe,
    TableExtensionService,
    SortService,
    JsonPipe
  ],
  declarations: [
    DownloadDialogComponent,
    TransactionDurationReportComponent,
    AsnRunTimeListComponent,
	OrderConfirmationRunTimeComponent,
    AsnRuntimeDownloadDialogComponent,
    ConfirmationDownloadDialogComponent,
    ApisRunTimeComponent,
    ApisRunTimeDownloadDialogComponent,
    InvoiceRuntimeDownloadDialogComponent,
	  InvoiceRunTimeComponent,
      TransactionDurationReportCapacityComponent,
      TransactionDurationReportCapacityDownloadDialogComponent
  ],
  entryComponents: [
	  DownloadDialogComponent,
	  TransactionDurationReportComponent,
	  AsnRunTimeListComponent,
	  OrderConfirmationRunTimeComponent,
	  AsnRuntimeDownloadDialogComponent,
	  ConfirmationDownloadDialogComponent,
	  ApisRunTimeComponent,
	  ApisRunTimeDownloadDialogComponent,
	  InvoiceRuntimeDownloadDialogComponent,
	  InvoiceRunTimeComponent,
      TransactionDurationReportCapacityComponent,
      TransactionDurationReportCapacityDownloadDialogComponent
  ]
})
export class TransactionReportsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transaction-reports/transaction-reports.module.ts